import { createSelector, createSlice } from '@reduxjs/toolkit';
import { getInformationMaterials } from 'api/InformationMaterials';
import { fetchWithLanguage } from 'store/helpers';

export const fetchInformationMaterials = fetchWithLanguage('fetchInformationMaterials', getInformationMaterials);

const informationMaterialsSlice = createSlice({
    name: 'InformationMaterialsSlice',
    initialState: {
        informationMaterials: {},
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchInformationMaterials.fulfilled, (state, action) => {
            state.informationMaterials = action.payload;
        });
    },
});

export const selectInformationMaterialsPage = createSelector(
    [state => state.informationMaterialsState.informationMaterials],
    informationMaterials => informationMaterials.data || {},
);

export default informationMaterialsSlice.reducer;
